import { Tooltip, Typography } from '@mui/material';
import React from 'react';

type KpiWorkunitGridData = {
  order?: {
    affair?: {
      bm?: { first_name?: string; last_name?: string };
    };
  };
};

const BmCell = React.memo((row: KpiWorkunitGridData) => (
  <span>
    {row?.order?.affair?.bm && (
      <Tooltip title={`${row.order.affair.bm.first_name} ${row.order.affair.bm.last_name}`}>
        <Typography variant="body2" noWrap>
          {`${row.order.affair.bm.first_name} ${row.order.affair.bm.last_name}`}
        </Typography>
      </Tooltip>
    )}
  </span>
));

export default BmCell;
